﻿import React from "react";
import { useAuth } from "oidc-react";
import { setExternalToken } from "../common/api/apiShared";
import DotLegalFullScreenSpinner from "../common/components/dotLegalFullScreenSpinner/DotLegalFullScreenSpinner";
import { isPdfRequest } from "@common/pdfUrlHelper.ts";

export interface IExternalUserLoaderProps {
    children: JSX.Element;
}

function ExternalUserLoader(props: IExternalUserLoaderProps) {
    const auth = useAuth();

    if (auth.userData) {
        setExternalToken(auth.userData.access_token);
    }

    if (!auth.userData && !isPdfRequest()) {
        return <DotLegalFullScreenSpinner />;
    }

    return <>{props.children}</>;
}

export default ExternalUserLoader;
